import { Chip, Grid, makeStyles, Paper } from '@material-ui/core';
import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import ReplayIcon from '@material-ui/icons/Replay';

const useStyles = makeStyles(theme => ({
  item: {
    padding: theme.spacing(1),
    color: theme.palette.error.contrastText,
    textAlign: 'center'
  },
  paper: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    textAlign: 'center',
    background: theme.palette.error.dark
  }
}))

/**
 * An error card that shows an error has occured. optionally can provide a refresh prop to add a try again chip and callback function.
 * @param { * } props props
 * @param { string } props.message additional information for error message.
 * @param { function } props.refresh function to call if you'd like to present a "Try Again" chip
 */
const CenteredError = ({ message, refresh }) => {
  const classes = useStyles();
  return (
    <Grid container justify="center">
      <Paper className={classes.paper}>
        <Grid item className={classes.item} xs={12}>
          <ErrorIcon></ErrorIcon>
        </Grid>
        <Grid item className={classes.item} xs={12}>
          An Error has occured. {message}
        </Grid>
        <Grid item className={classes.item} xs={12}>
          {refresh &&
            <Chip icon={<ReplayIcon />} label="Try Again." variant="outlined" onClick={refresh} />
          }
        </Grid>
      </Paper>
    </Grid>
  )
}

export default CenteredError;